<template>
	<div style="width:90%">
		<!-- 查询 -->
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
                    <el-form-item label="用户名" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.buyerName" placeholder="请输入用户名"></el-input>
					</el-form-item>
                    <el-form-item label="订单编号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.orderCode" placeholder="请输入订单号">
						</el-input>
					</el-form-item>
                    <!-- 平台才能看见 -->
                    <el-form-item label="选择店铺" v-if="stoId==0">
						<el-select v-model="searchInfo.storeId" class="big" placeholder="请选择">
							<el-option v-for="item in selectStoreName" :key="item.id" :value="item.id"
								:label="item.storeName">
							</el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label="售后状态" >
						<el-select v-model="searchInfo.status" class="big" placeholder="请选择">
							<el-option key="1" :value="1" label="待处理"></el-option>
							<el-option key="2" :value="2" label="同意退款"></el-option>
							<el-option key="3" :value="3" label="快递寄回"></el-option>
							<el-option key="4" :value="4" label="商家签收"></el-option>
							<el-option key="5" :value="5" label="售后完成"></el-option>
							<el-option key="6" :value="6" label="驳回申请"></el-option>
							<el-option key="7" :value="7" label="用户撤销"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label="申请时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="downloadFile">
								导出
								<a href=""></a>
							</el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<!-- 列表展示 -->
		<el-table :data="sliderlist.list" stripe style="width: 100%" v-loading="loading" element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading">
            <el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand" label-width="150px"
                    style="margin-left:80px">
						<el-form-item label="购买人">
							<span >{{ props.row.buyerName }}</span>
						</el-form-item>
                        <el-form-item label="联系方式">
							<span>{{ props.row.buyerPhone }}</span>
						</el-form-item>
                        <el-form-item label="店铺名称">
							<span>{{ props.row.storeName }}</span>
						</el-form-item> 
						<el-form-item label="分销店铺名称">
							<span>{{ props.row.bstoreName }}</span>
						</el-form-item>
					</el-form>
				</template>
            </el-table-column>
			<el-table-column prop="orderId" label="订单ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="orderCode" label="订单编号" align="center"  width="200">
			</el-table-column>
			<el-table-column prop="type" label="售后类型" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.type==2">退货退款</span>
					<span v-if="scope.row.type==1">仅退款</span>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="images" label="申请凭证" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                </template>
			</el-table-column> -->
            <el-table-column prop="reason" label="申请理由" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="amount" label="退款总金额(￥)" align="center"  :show-overflow-tooltip="true">
			</el-table-column>
            <!-- <el-table-column prop="orderStatus" label="售后前订单状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.orderStatus==0">待付款</span>
					<span v-if="scope.row.orderStatus==1">待发货</span>
					<span v-if="scope.row.orderStatus==2">待收货</span>
					<span v-if="scope.row.orderStatus==3">已完成</span>
					<span v-if="scope.row.orderStatus==4">退款申请</span>
					<span v-if="scope.row.orderStatus==5">已退款</span>
					<span v-if="scope.row.orderStatus==6">部分退款</span>
					<span v-if="scope.row.orderStatus==7">已失效</span>
					<span v-if="scope.row.orderStatus==8">驳回</span>
					<span v-if="scope.row.orderStatus==9">取消</span>
				</template>
			</el-table-column> -->
            <!-- <el-table-column prop="isAgreePc" label="平台处理结果" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="isAgree" label="供应商处理结果" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="createTime" label="申请时间" align="center"  :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="status" label="售后状态" align="center"  :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status == 1" style="color:#E6A23C;font-weight: bold;">待处理</span>
					<span v-if="scope.row.status == 2" style="color:#67C23A">同意退款</span>
					<span v-if="scope.row.status == 3" style="color:#82848a">快递寄回</span>
					<span v-if="scope.row.status == 4" style="color:#82848a">商家签收</span>
					<span v-if="scope.row.status == 5" style="color:#67C23A">售后完成</span>
					<span v-if="scope.row.status == 6" style="color:#F56C6C">驳回申请</span>
					<span v-if="scope.row.status == 7" style="color:#82848a">用户撤销</span>
				</template>
			</el-table-column>
            <el-table-column prop="rejectReason" label="驳回理由" align="center"  :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="returnDate" label="处理时间" align="center"  :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column label="操作" align="center" fixed="right"  width="200" >
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showContent(scope.row)">订单详情</el-button>
					<el-button v-if="scope.row.status==1" size="small" type="text" @click="showDeliver(scope.row)">
                        处理售后
					</el-button>

					<el-button v-if="scope.row.status==3" size="small" type="text" @click="showDeliverTwo(scope.row)">
                        处理售后
					</el-button>

					<el-button v-if="scope.row.status==4 && stoId==0" size="small" type="text"
					 @click="record(scope.row.id, '2')"> 处理售后 </el-button>

					<!-- <el-button size="small" type="text" @click="lookexp(scope.row.expressCode)">物流</el-button> -->
					<el-button size="small" type="text" @click="record(scope.row.id, '1')">处理记录</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 订单详情对话框 -->
		<el-dialog title="订单详情" :visible.sync="dialogVisible" width="60%" :before-close="handleClose"
			:close-on-click-modal="false">
			<div>
				<div style="margin:10px 0 ;">
					<strong>商品详情</strong>&nbsp;&nbsp;&nbsp;&nbsp;
				</div>

				<div class="orderList">
					<div class="orderxq" v-for="(item,index) in orderInfo.goodsList" :key="index">
						<div>
							<img :src="item.images.split(',')[0]" alt="" style="width:100px;height:100px;">
						</div>
						<div style="margin-left:20px;">
							<p>商品名称：{{item.goodsName}}</p>
							<p>供应商名称：{{orderInfo.supplierName}}</p>
							<p>购买数量：{{item.num}}</p>
							<p>单价：{{item.price}}</p>
						</div>
					</div>
				</div>
				<el-form v-model="orderInfo" label-position="left" inline class="demo-table-expand">
					<el-form-item label="订单号">
						<span>{{orderInfo.orderCode?orderInfo.orderCode:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="支付类型">
						<span v-if="orderInfo.payType=='wx'">微信支付</span>
						<span v-if="orderInfo.payType=='Ali_Pay'">支付宝支付</span>
						<span v-if="orderInfo.payType=='integral'">积分抵扣-{{orderInfo.integralName}}</span>
						<span v-if="orderInfo.payType=='wx_plural'">微信积分混合支付</span>
						<span v-if="orderInfo.payType=='huiJu_Ali_Pay'">汇聚支付宝支付</span>
						<span v-if="orderInfo.payType=='huiJu_Quick_Pay'">汇聚快捷支付</span>
						<span v-if="orderInfo.payType=='yl_wxapplet_pay'">银联微信支付</span>
					</el-form-item>
					<el-form-item label="所属区域">
						<span>{{orderInfo.province}}{{orderInfo.city}}{{orderInfo.area}}</span>
					</el-form-item>
					<el-form-item label="订单状态">
						<span v-if="orderInfo.status==0">待付款</span>
						<span v-if="orderInfo.status==1">待发货</span>
						<span v-if="orderInfo.status==2">待收货</span>
						<span v-if="orderInfo.status==3">已完成</span>
						<span v-if="orderInfo.status==4">退款申请</span>
						<span v-if="orderInfo.status==5">已退款</span>
						<span v-if="orderInfo.status==6">部分退款</span>
						<span v-if="orderInfo.status==7">已失效</span>
						<span v-if="orderInfo.status==8">驳回</span>
						<span v-if="orderInfo.status==9">取消</span>
					</el-form-item>
					<el-form-item label="订单总价">
						<span>{{orderInfo.orderTotalPrice?"￥"+orderInfo.orderTotalPrice:'暂无'}}</span>
					</el-form-item>
				
					<el-form-item label="支付金额">
						<span>{{orderInfo.cashNum?"￥"+orderInfo.cashNum:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="积分抵扣">
						<span>{{orderInfo.integralNum?+orderInfo.integralNum:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="收货人">
						<span>{{orderInfo.name?orderInfo.name:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="联系电话">
						<span>{{orderInfo.phone?orderInfo.phone:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="详细地址">
						<span>{{orderInfo.province}}{{orderInfo.city}}{{orderInfo.area}}{{orderInfo.address}}</span>
					</el-form-item>
					<el-form-item label="购买时间">
						<span>{{orderInfo.createTime?orderInfo.createTime:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="快递公司">
						<span>{{orderInfo.expressName?orderInfo.expressName:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="快递单号">
						<span>{{orderInfo.expressCode?orderInfo.expressCode:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="发货人">
						<span>{{orderInfo.sendOpUser?orderInfo.sendOpUser:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="发货时间">
						<span>{{orderInfo.sendTime?orderInfo.sendTime:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="确认收货时间">
						<span>{{orderInfo.completeTime?orderInfo.completeTime:'暂未确认'}}</span>
					</el-form-item>
					<!-- <el-form-item label="查看物流" v-if="orderInfo.status==2||orderInfo.status==3">
						<span @click="lookexp(orderInfo.expressCode)" style="color: green;border-bottom: 1px solid green;">立即查看</span>
					</el-form-item> -->
					<el-form-item label="备注">
						<span>{{orderInfo.remark?orderInfo.remark:'暂无'}}</span>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
				<el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
		<el-dialog style="float:rigin;overflow-y: scroll;" title="物流详情" :visible.sync="ExpDialog" width="60%"
			:close-on-click-modal="false">
		
				<el-steps :active="wudetail.length" align-center direction="vertical">
				  <el-step v-for="(item,index) in wudetail" :key="index"  :title="item.context" :description="item.ftime"></el-step>
				</el-steps>
		
			
		
		</el-dialog>
		<!-- 处理售后 -->
		<el-dialog style="float:rigin" title="处理售后" :visible.sync="deliverDialog" width="30%"
			:close-on-click-modal="false">
			<div class="app-container" style="text-align: center;">
				<el-form label-width="120px" size="medium">
					<el-form-item label="售后类型:">
						<span v-if="afterSaleInfo.type==2">退货退款</span>
						<span v-if="afterSaleInfo.type==1">仅退款</span>
					</el-form-item>
					<el-form-item label="售后原因:">
						<span>{{afterSaleInfo.reason}}</span>
					</el-form-item>
					<el-form-item label="凭证:" v-if="afterSaleInfo.images">
						<div style="display: flex;align-items: center;width:100%;flex-wrap:wrap">
							<img v-for="(item,index) in afterSaleInfo.images.split(',')" :src="item" @click="clickImg(item)"
							:key="index" style="width: 100px;height: 100px;">
						</div>
					</el-form-item>
					<el-form-item label="退款总金额(￥):">
						<span>{{afterSaleInfo.amount}}</span>
					</el-form-item>

                    <el-form-item label="处理结果:">
						<el-radio-group v-model="disposeType">
                            <el-radio :label="1">同意退款</el-radio>
                            <!-- <el-radio :label="2">同意退货</el-radio> -->
                            <el-radio :label="0">驳回</el-radio>
                        </el-radio-group>
					</el-form-item>
					<el-form-item label="驳回原因:" v-if="disposeType==0">
						<el-input type="textarea" :rows="2" v-model="disposeReason" placeholder="请输入驳回原因" />
					</el-form-item>
					<div v-if="disposeType==1&&afterSaleInfo.type==2">
						<el-form-item label="收件人:" >
							<el-input type="text"  v-model="realName" placeholder="请输入收件人" />
						</el-form-item>
						<el-form-item label="联系电话:" >
							<el-input type="text"  v-model="phone" placeholder="请输入联系电话" />
						</el-form-item>
						<el-form-item label="回寄地址:" >
							<el-input type="textarea" :rows="2"  v-model="address" placeholder="请输入回寄地址，详细的地址" />
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="deliverDialog = false">取 消</el-button>
				<el-button type="primary" @click="deliverGoods" :loading="deliverGoodsLoading">确 定</el-button>
			</div>
		</el-dialog>

        <!-- 售后处理记录 -->
        <el-dialog style="float:rigin" title="处理记录" :visible.sync="deliverDialogRecord" width="900px"
			:close-on-click-modal="false">
			<div style="display: flex;">
				<div style="width:400px">
					<div >
						<strong>售后详情</strong>&nbsp;&nbsp;&nbsp;&nbsp;
					</div>
					<el-form label-width="80px" size="medium">
						<el-form-item label="售后类型:" >
							<span v-if="recordList.type==2">退货退款</span>
							<span v-if="recordList.type==1">仅退款</span>
						</el-form-item>
						<el-form-item label="售后原因:">
							<span >{{recordList.reason}}</span>
						</el-form-item>
						<el-form-item label="凭证:" v-if="recordList.images">
							<div style="display: flex;align-items: center;width:100%;flex-wrap:wrap">
								<img v-for="(item,index) in recordList.images.split(',')" :src="item" @click="clickImg(item)"
								:key="index" style="width: 100px;height: 100px;">
							</div>
						</el-form-item>
						<el-form-item label="申请时间:" >
							<span >{{recordList.returnDate}}</span>
						</el-form-item>
						<el-form-item label="售后编号:" >
							<span >{{recordList.returnCode}}</span>
						</el-form-item>
					</el-form>
				</div>

				<div style="flex:1;">
					<el-timeline>
						<el-timeline-item v-for="(activity, index) in recordList.goodsReturnsGoodsDtos"
						:timestamp="activity.createTime" placement="top" :key="index">
							<el-card>
								<h4>{{activity.message}}</h4>
								<div v-if="activity.message=='买家已发货'">
									<div>
										<span>快递公司：</span>
										<span>{{activity.company}}</span>
									</div>
									<div>
										<span>快递单号：</span>
										<span>{{activity.sn}}</span>
									</div>
								</div>
								<div v-if="activity.message=='商家拒绝退款'">
									<div>
										<span>拒绝理由：</span>
										<span>{{activity.rejectReason}}</span>
									</div>
								</div> 
								<div v-if="activity.message=='商家不同意退款,请经行协商'">
									<div>
										<span>拒绝理由：</span>
										<span>{{activity.rejectReason}}</span>
									</div>
									<div style="display: flex;">
										<div style="width:90px">图片：</div>
										<div style="display: flex;align-items: center;width:100%;flex-wrap:wrap">
											<img v-for="(item,index) in activity.images.split(',')" :src="item" @click="clickImg(item)"
											:key="index" style="width: 100px;height: 100px;">
										</div>
									</div>
								</div>
							</el-card>
						</el-timeline-item>
					</el-timeline>
				</div>
			</div>
			<div style="padding:30px 0 ;">
				<div v-if="gly==2">
					<div >
						<strong>平台处理</strong>
					</div>
					<div style="height: 20px;"></div>
					<el-form label-width="120px" size="medium">
						<el-form-item label="处理结果:">
							<el-radio-group v-model="isAgreePc">
								<el-radio :label="1">同意退款</el-radio>
								<el-radio :label="0">不同意</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="驳回原因:" v-if="isAgreePc==0">
							<el-input type="textarea" :rows="2" v-model="reasonGLY" placeholder="请输入驳回原因" />
						</el-form-item>
					</el-form>
				</div>
			</div>
			
            <div slot="footer" class="dialog-footer">
				<el-button @click="deliverDialogRecord = false">关闭</el-button>
				<el-button v-if="gly==2" @click="platformIntervention" :loading="kejrLoading" 
				type="primary">确认</el-button>
			</div>
        </el-dialog>

		<!-- 图片查看 -->
		<el-dialog :visible.sync="dialogImg" :closeOnClickModal="false" width="700px" >
			<div style="text-align: center;">
				<img width="600px" style="width:600px;height:auto" :src="popupImageUrl">
			</div>
			<div style="height:30px"></div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogImg = false">关 闭</el-button>
			</div>
		</el-dialog>


		<!-- 商家签收 -->
		<el-dialog style="float:rigin" title="处理售后" :visible.sync="signForDialog" width="50%"
			:close-on-click-modal="false">
			<div class="app-container" style="text-align: center;">
				<el-form label-width="120px" size="medium">
                    <el-form-item label="处理结果:">
						<el-radio-group v-model="isAgreeGys">
                            <el-radio :label="1">同意退款</el-radio>
                            <el-radio :label="0">不同意</el-radio>
                        </el-radio-group>
					</el-form-item>
					<el-form-item label="驳回原因:" v-if="isAgreeGys==0">
						<el-input type="textarea" :rows="2" v-model="reasonTwo" placeholder="请输入驳回原因" />
					</el-form-item>
					<el-form-item label="图片:" v-if="isAgreeGys==0">
						<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
							:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" :limit="3"
							:on-success="onSuccess1">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="signForDialog = false">取 消</el-button>
				<el-button type="primary" @click="signForGoods" :loading="signForLoading">确 定</el-button>
			</div>
		</el-dialog>


		<!-- 管理员处理售后 -->
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('afterSale');
	export default {
		data() {
			return {
				httpUrl: urls,
				loading: false,
				dialogVisible: false,
				searchInfo: {},
				orderInfo: {},
				sliderlist: {},
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				deliverDialog: false, //发货弹窗
                selectStoreName:[], //选择店铺的店铺列表
                stoId:'', //登录人的店铺ID
				supplierId:'', // 供应商id 
				ExpDialog:false,
                wudetail:[{}],

                disposeType: 1, //处理结果类型
				disposeReason: '', //驳回原因
				realName: '', //收件人
				phone: '', //电话
				address: '', //地址
                afterSaleInfo: {}, // 售后记录数据
                deliverDialogRecord: false, // 处理记录弹窗
                loadingRecord: false,  // 处理记录表格
                deliverGoodsLoading: false, //售后处理结果按钮
				
				dialogImg:false,
				popupImageUrl:'',

				recordList: {},

				signForDialog: false,
				signForInfo: {},
				signForLoading: false,
				isAgreeGys: 1,
				reasonTwo: '',
				fileList: [],
				images: [],
				gly: '',
				kejrLoading: false,
				isAgreePc: 1,
				reasonGLY: ''
			};
		},
		filters: {
			ggfilter(val){
				let v=val.split(',')
				if(v[0]==''){
					return val.split(',')[1]
				}
				if(v[1]==''){
					return val.split(',')[0]
				}
				else{
					return val
				}
			},
		},
		methods: {
			platformIntervention(){
				this.kejrLoading = true
				let data={
                    id: this.recordList.id,
                    isAgreePc: this.isAgreePc //类型: 1(同意) 0(不同意)
                }
                if(this.isAgreePc == 0){
					data.rejectReason = this.reasonGLY; //驳回理由
				}
				
				this.$api.platformIntervention(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.storeOrderList();
						this.deliverDialogRecord = false
					} else {
						this.$message.error(res.message);
                    }
                    this.kejrLoading = false
				})
			},
			onSuccess1(response, file) {
				// console.log(response)
				this.images.push(response.message)
				this.fileList.push({
					"url": response.message
				})
				// console.log("asda", this.fileList)
			},
			handlePictureCardPreview(file) {
				this.popupImageUrl = file.url;
				this.dialogImg = true;
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.images.remove(file.response.message);
				}
				// this.goodsImages.remove(file.url);
				this.fileList = this.fileList.filter(item => item.uid !== file.uid)
			},
			//售后处理弹窗
			showDeliverTwo(item) {
				// console.log(item);
				this.signForInfo = item
				this.isAgreeGys = 1;
                this.reasonTwo = "";
				this.signForDialog = true
			},
			signForGoods(){ //商家签收快递同意或不同意退款
				this.signForLoading = true
				let data={
                    id: this.signForInfo.id,
                    isAgreeGys: this.isAgreeGys //类型: 1(同意) 0(不同意)
                }
                if(this.isAgreeGys == 0){
					data.rejectReason = this.reasonTwo; //驳回理由
					data.images = this.images.join(',')
				}
				
				this.$api.disposeOrderAfterSalePcTwo(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.storeOrderList();
						this.signForDialog = false
					} else {
						this.$message.error(res.message);
                    }
                    this.signForLoading = false
				})
			},
			clickImg(e) { //图片查看
				this.popupImageUrl = e;
				this.dialogImg = true;
			},
			record(e, num){ //处理记录
				this.gly = num;
                this.$api.orderAfterSaleProcessingRecordPc(e).then(res=>{
					if(res.state=='success'){
						// console.log('处理记录---', res)
						this.recordList = res.data;
					}
				})
                this.deliverDialogRecord = true;
            },
			lookexp(id){
					
				this.$api.lookExpress(id).then(res=>{
					
					if(res.state=='success'){
						this.ExpDialog=true
						this.wudetail=JSON.parse(res.data.detail).reverse()
					}else{
						this.$message.error(res.message);
					}
				})
			},
			/**
			 * 文件导出
			 */
			downloadFile() {
				let data = {
                    orderCode: this.searchInfo.orderCode,
                    storeId: this.searchInfo.storeId,
                    status: this.searchInfo.status,
                    buyerName: this.searchInfo.buyerName,
                    startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
                    endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.exportExcel(data).then((res) => {
					// console.log(res.data)
					this.showloadFile(res.data)
				})
			},
			showloadFile(res) {
				if (!res) {
					return
				}
				const link = document.createElement('a');
				let blob = new Blob([res], {
					type: 'application/vnd.ms-excel'
				});
				link.style.display = 'none';
				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', '售后记录' + '.xls');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			
            deliverGoods() { //确认处理结果
                this.deliverGoodsLoading = true
                let data={
                    id: this.afterSaleInfo.id,
                    isAgree: this.disposeType //类型: 1(同意) 0(不同意)
                }
                if(this.disposeType == 0){
                    data.rejectReason = this.disposeReason; //驳回理由
				}
				if(this.disposeType == 1 && this.afterSaleInfo.type==2){
					data.realName = this.realName;
					data.phone = this.phone;
					data.address = this.address;
				}
				
				this.$api.disposeOrderAfterSalePc(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.storeOrderList();
						this.deliverDialog = false
					} else {
						this.$message.error(res.message);
                    }
                    this.deliverGoodsLoading = false
				})

			},
			//展示售后处理弹窗
			showDeliver(item) {
				// console.log(item);
                this.afterSaleInfo = item
                this.disposeReason = "";
				this.deliverDialog = true
			},
			// 查询
			search() {
				this.page.pageNum = 1;
				this.storeOrderList()
			},
			// 清空
			empty() {
				this.searchInfo = {}

			},
			storeOrderList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
                    pageSize: this.page.pageSize,
                    orderCode: this.searchInfo.orderCode,
                    storeId: this.searchInfo.storeId,
                    status: this.searchInfo.status,
                    buyerName: this.searchInfo.buyerName,
                    startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
                    endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
					
                }
                // this.$encrypt(data)
				this.$api.orderAfterSaleListPc(data).then((res => {
					// res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.sliderlist = res.data
						this.loading = false
					}
				}))

			},

			// 订单详情查询
			showContent(e) {
				let data = {
					id: e.orderId,
					// areaId: e.areaId,
					// provinceId: e.provinceId,
					// cityId: e.cityId
				}
				this.$api.findOrderInfo(e.orderId).then((res) => {
					// res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.orderInfo = res.data
						// console.log(res.data)
						this.dialogVisible = true
					} else {
						this.$message.error(res.message)
					}
				})
			},
			handleClose() {
				this.dialogVisible = false
			},
			pageChange(val) {
				this.page.pageNum = val
				this.storeOrderList();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.storeOrderList()
			},
			selectStore(){ 
				this.$api.getStoreNameList().then(res=>{
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					if(res.state == 'success'){
						this.selectStoreName = res.data
					}else {
						this.$message.error(res.message);
					}
				})
            },
            logInUserInfo(){ //查询登录人信息
				this.$api.getUserInfo(this.$encrypt({})).then(res => {
					res.data = JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						// console.log('登录人信息---', res.data )
						// supplierId(有值就是供应商)
						this.stoId = res.data.storeId; // storeId：0(平台)   
					}
				})
				
			}
		},

		created() {
			this.storeOrderList();
            this.selectStore();
            this.logInUserInfo();

		},
	};
</script>

<style  scoped>
	.orderxq {
		display: flex;
		width: 50%;
		align-items: flex-start;
		margin-bottom: 30px;
        
	}

	.orderList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

	}


</style>
